module.exports = __webpack_public_path__ + "static/img/coupons_lapse.7592925.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/coupons_lapse.jpg
// module id = 586
// module chunks = 0